module.exports = __webpack_public_path__ + "static/media/teatro.29f4e384.mpeg";